import React from 'react'

import classNames from './DatePicker.css'
import ConfirmButtons from '../ConfirmButtons'
import GenericIncludeExcludePicker from './GenericIncludeExcludePicker'

export default function DatePicker ({ value, onChange, onCancel, addTerm, showDynamic, options, targetDate, updateTargetDate }) {
  const onChangeType = e => onChange({
    ...value,
    dynamic: e.target.value === 'filter-only' ? undefined : e.target.value,
    margin: undefined,
    filterOnly: e.target.value === 'filter-only' ? true : undefined
  })
  const onChangeFactory = key => e => onChange({
    ...value,
    [key]: e.target.value || undefined
  })
  const onChangeNumberFactory = key => e => onChange({
    ...value,
    [key]: parseInt(e.target.value) || undefined
  })
  const onChangeValueFactory = key => newValue => onChange({
    ...value,
    [key]: newValue || undefined
  })
  const defaultToday = new Date().toISOString().slice(0, 10)
  return (
    <div className={classNames.picker}>
      <label>
        Type
        <br />
        <select onChange={onChangeType} value={value.dynamic}>
          <option value=''>Date Range</option>
          {showDynamic &&
            <option value='recent'>Recent Pictures</option>
          }
          {showDynamic &&
            <option value='on-this-day'>On This Day</option>
          }
          <option value='filter-only'>Time of day/season only</option>
        </select>
      </label>
      <div>
        {!value.dynamic && !value.filterOnly &&
          <label className={classNames.column}>
            Start date
            <input
              type='date'
              value={value.start || ''}
              onChange={onChangeFactory('start')}
              placeholder='yyyy-mm-dd'
            />
          </label>
        }
        {value.dynamic &&
          <label className={classNames.column}>
            {value.dynamic === 'recent' ? 'Backwards from' : 'Target date'}
            {!value.start &&
              <div className={classNames.todayPlaceholder}>
                Today
                <button type='button' className={classNames.setDateButton} onClick={onChangeFactory('start')} value={defaultToday}>
                  Fix to date
                </button>
              </div>
            }
            {value.start &&
              <input
                type='date'
                value={value.start}
                onChange={onChangeFactory('start')}
                placeholder='yyyy-mm-dd'
              />
            }
          </label>
        }
        {!value.dynamic && !value.filterOnly &&
          <label className={classNames.column}>
            End date
            {!value.end &&
              <div className={classNames.todayPlaceholder}>
                Today
                <button type='button' className={classNames.setDateButton} onClick={onChangeFactory('end')} value={defaultToday}>
                  Fix to date
                </button>
              </div>
            }
            {value.end &&
              <input
                type='date'
                value={value.end}
                onChange={onChangeFactory('end')}
                placeholder='yyyy-mm-dd'
              />
            }
          </label>
        }
        {value.dynamic &&
          <label className={classNames.column}>
            {value.dynamic === 'recent' ? 'Number of months back' : '+/- number of days'}
            <input
              type='number'
              value={value.margin || (value.dynamic === 'recent' ? 1 : 0)}
              onChange={onChangeNumberFactory('margin')}
              className={classNames.numberInput}
              min={0}
            />
          </label>
        }
        {value.dynamic === 'on-this-day' && value.start && value.margin > 0 &&
          <label>
            <input
              type='checkbox'
              checked={targetDate === value.start}
              onChange={() => updateTargetDate(targetDate === value.start ? undefined : value.start)}
            />
            Sort by date accuracy (exact date first)
          </label>
        }
        {value.dynamic === 'on-this-day' &&
          <label className={classNames.column}>
            Year
            <select onChange={onChangeFactory('yearType')} value={value.yearType}>
              <option value='since'>Since</option>
              <option value='exact'>Exact Year</option>
            </select>
          </label>
        }
        {value.dynamic === 'on-this-day' &&
          <label className={classNames.column}>
            {' '.replace(/ /g, '\u00a0')}
            <input
              type='number'
              value={value.year || ''}
              onChange={onChangeNumberFactory('year')}
              className={classNames.numberInput}
              placeholder='yyyy'
            />
          </label>
        }
        <label className={classNames.noBottomMargin}>
          Time of Day
        </label>
        <GenericIncludeExcludePicker
          options={options.timesOfDay}
          value={value.dayperiod || []}
          onChange={onChangeValueFactory('dayperiod')}
        />
        <label className={classNames.noBottomMargin}>
          Season
        </label>
        <GenericIncludeExcludePicker
          options={options.seasons}
          value={value.season || []}
          onChange={onChangeValueFactory('season')}
        />
        {!value.filterOnly &&
          <label>
            Date Confidence
            <select value={value.confidence} onChange={onChangeFactory('confidence')} style={{ width: 'auto' }}>
              <option value={undefined}>Exact</option>
              <option value='months'>Loosen Day</option>
              <option value='seasons'>Loosen Month</option>
              <option value='years'>Loosen Season</option>
              <option value='decades'>Loosen Year</option>
            </select>
          </label>
        }
      </div>
      <ConfirmButtons
        onCancel={() => {
          onCancel()
          onChange({})
        }}
        confirmText='Submit'
        onConfirm={() => {
          addTerm('date', value)
          onChange({})
        }}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/search/DatePicker.js